import { Flex, Text } from '@chakra-ui/react';
import { Button, Modal } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';
import { ISearchQueryItems } from 'src/api/queries';
import { getPropertyStrings } from './types';

interface Props {
  item: ISearchQueryItems;
  onClose: () => void;
  onDelete: () => void;
  isDeleting: boolean;
}

const DeleteReviewerSearchUserModal = ({
  item,
  onClose,
  onDelete,
  isDeleting
}: Props) => {
  const email =
    getPropertyStrings(item.properties, 'ReviewerPrimaryEmailAddress')?.[0] ??
    '';

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      width="448px"
      closeButtonProps={{ hidden: true }}
    >
      <Flex flexDirection="column" gap={6} padding={8}>
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          style={{ width: '40px', height: '40px' }}
          color="actionSecondaryCautionContent"
        />

        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingGroup">Delete Reviewer?</Text>
          <Text textStyle="textBody">
            {email
              ? `"${email}" will be removed from this journal's reviewer search.`
              : 'This reviewer will be removed from this journal’s reviewer search.'}
          </Text>
        </Flex>

        <Flex justifyContent="flex-end" gap={2}>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="caution" onClick={onDelete} isLoading={isDeleting}>
            Delete Reviewer
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default DeleteReviewerSearchUserModal;
